import qs from 'query-string';
import config from './config';

const getThdLoginUrl = (returnPath) => {
  const queryParams = qs.stringify({ redirect: returnPath, ref: config.baseUrl.replace(/^https?:\/\//, '') });
  return `${config.thdFullPageLogin}?${queryParams}`;
};

export default getThdLoginUrl;
